import { accountsAPI } from '@/services';
import { storeSessionMenu } from '@/utils/sessionMenu';

export default {
  SET_USER_DATA({ commit }, payload) {
    storeSessionMenu(payload);
    commit('SET_USER_DATA', payload);
  },
  SET_CHANGE_PASSWORD_REQUIREMENT({ commit }, payload) {
    commit('SET_CHANGE_PASSWORD_REQUIREMENT', payload);
  },
  SET_PROMOTER_ACCESSES({ commit }, payload) {
    commit('SET_PROMOTER_ACCESSES', payload);
  },
  /** Rejects on failure: the modal shows it, the header count chooses to ignore it. */
  async LOAD_PROMOTER_ACCESSES({ commit, state }) {
    if (state.promoterAccesses.length) return;

    const response = await accountsAPI.getPromoterAccesses();

    commit('SET_PROMOTER_ACCESSES', response?.data?.links || []);
  },
};
